import { Component, OnInit } from '@angular/core';
import { RouterService } from '../../../service/core/router.sevice';

@Component({
  selector: 'app-footbar',
  templateUrl: './footbar.component.html',
  styleUrls: ['./footbar.component.scss']
})
export class FootbarComponent implements OnInit {

  constructor(private route: RouterService) { }

  ngOnInit() {
  }

  goto(url){
    this.route.go(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/ui/footbar/footbar.component.ts